export default {
    request: {},
    clientRequestData: {},
    permanentInstruction: {},
    transferRedirect: false
  }
  